import React from 'react'
import { RuleSet } from 'styled-components'
import { DefaultButton, PrimaryButton, SecondaryButton } from 'src/components/Button/styled'
import RenderIf from 'src/components/RenderIf'

interface ButtonProps {
  name?: string
  onClick: any
  $style?: RuleSet<object>
  renderIf?: boolean
  disabled?: boolean
}

const OtpCertRequestButton = (props: ButtonProps) => {
  const { name = '인증번호 발송', renderIf = true, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton {...remainProps} className="btn_send_sms">
        {name}
      </PrimaryButton>
    </RenderIf>
  )
}

const ReTryOtpCertRequestButton = (props: ButtonProps) => {
  const { name = '재발송', renderIf = true, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <SecondaryButton {...remainProps} className="btn_send_sms">
        {name}
      </SecondaryButton>
    </RenderIf>
  )
}

const JoinSubmitButton = (props: ButtonProps) => {
  const { name = '휴대폰쿠폰지갑 유료부가서비스가입', renderIf = true, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton {...remainProps} className="btn_signup">
        {name || '휴대폰쿠폰지갑 유료부가서비스가입'}
      </PrimaryButton>
    </RenderIf>
  )
}

const CancelResetButton = (props: ButtonProps) => {
  const { name = '취소', renderIf = true, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <DefaultButton {...remainProps} className="btn_cancel">
        {name}
      </DefaultButton>
    </RenderIf>
  )
}
const JoinSubmitFloatButton = (props: ButtonProps) => {
  const { name = '휴대폰쿠폰지갑 서비스 가입(유료)', renderIf = true, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton {...remainProps} className="btn_floating_sms">
        {name}
      </PrimaryButton>
    </RenderIf>
  )
}
export const Button = {
  Default: DefaultButton,
  Primary: PrimaryButton,
  Secondary: SecondaryButton,
  JoinSubmit: JoinSubmitButton,
  OtpCertRequest: OtpCertRequestButton,
  RetryOtpCertRequest: ReTryOtpCertRequestButton,
  CancelReset: CancelResetButton,
  JoinSubmitFloat: JoinSubmitFloatButton,
}
